import { Controller } from "@hotwired/stimulus";
import { gsap, Power2, ScrollToPlugin } from "gsap/all";
import * as Turbo from "@hotwired/turbo";

gsap.registerPlugin(ScrollToPlugin);

let paginationScroll = null;

export default class extends Controller {
  static values = {
    offset: { type: Number, default: 20 },
    mobileOffset: { type: Number, default: 96 },
    mobileBreakpoint: { type: Number, default: 1024 },
    duration: { type: Number, default: 0.5 },
  };

  get currentOffset() {
    return window.innerWidth < this.mobileBreakpointValue
      ? this.mobileOffsetValue
      : this.offsetValue;
  }

  click(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const url = new URL(link.href);
    const targetId = url.hash.replace(/^#/, "");

    if (!targetId) return;

    paginationScroll = {
      targetId,
      offset: this.currentOffset,
      duration: this.durationValue,
      startY: window.scrollY,
    };

    url.hash = "";
    Turbo.visit(url.toString(), { action: "replace" });
  }
}

document.addEventListener("turbo:render", () => {
  if (!paginationScroll) return;

  const { targetId, offset, duration, startY } = paginationScroll;
  paginationScroll = null;

  const target = document.getElementById(targetId);
  if (!target) return;

  window.scrollTo(0, startY);

  gsap.to(window, {
    duration,
    ease: Power2.easeInOut,
    scrollTo: {
      y: target,
      offsetY: offset,
      autoKill: false,
    },
  });
});
